<template>
  <div class="pc_footer">
    <div class="footer-container">
      <div class="w">
        <div class="top">
          产业链供应链数字化综合服务平台实战派专家团队
        </div>
        <div class="bottom">
          <div class="left">
            <div class="box">
              <img src="../../assets/img/layout/footer1.png" alt="" />
              <div class="name">
                <p>知识</p>
                <p>(总裁顾问)</p>
              </div>
              <div class="list-item">
                <p>一张数字化供应链平台建设总蓝图</p>
                <p>一个平台运营工具包</p>
                <p>运营产品与流程指导</p>
                <p>多份行业分析报告分享</p>
                <p>多次面对面及远程的培训交流分享</p>
              </div>
            </div>
            <div class="box">
              <img src="../../assets/img/layout/footer2.png" alt="" />
              <div class="name">
                <p>科技</p>
                <p>(系统开发与实施)</p>
              </div>
              <div>
                <div class="list-top">
                  <i>1</i>大门户平台 <i>1</i>个预警平台 <i>1</i>个数据中台
                  <i>10</i>大应用子平台
                </div>
                <div class="flex-row">
                  <div class="list-item">
                    <p>AI智慧风控系统</p>
                    <p>进口贸易管理系统</p>
                    <p>转口贸易管理系统</p>
                    <p>数字营销系统</p>
                    <p>供应链金融系统</p>
                  </div>
                  <div style="margin-left: 30px" class="list-item">
                    <p>外贸综合服务平台</p>
                    <p>出口贸易管理系统</p>
                    <p>商贸云Saas平台</p>
                    <p>员工数字名片系统</p>
                    <p>跨境供应链综合服务系统</p>
                  </div>
                </div>
                <div>
                  (系统架构：微服务，SaaS模式，多租户，数据库可分开部署)
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="right">
            <img class="logo" src="../../assets/img/layout/logo.png" alt="" />
            <div class="code">
              <div class="img">
                <img src="../../assets/img/layout/xcx.png" alt="" />
                <div>微信小程序</div>
              </div>
              <div class="img">
                <img src="../../assets/img/layout/code.png" alt="" />
                <div>与海平老师交流</div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="company">
      <div class="w">
        Copyright ©2016 深圳海平创新知识服务有限公司 版权所有
        <a style="color: #000" target="_blank" href="https://beian.miit.gov.cn"
          >粤ICP备19110474号</a>
        <a style="color: #000" target="_blank" href="https://beian.miit.gov.cn"
          >粤ICP备19110474号-1</a>
        <a style="color: #000" target="_blank" href="https://beian.miit.gov.cn"
          >粤ICP备19110474号-2</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {}
}
</script>

<style lang="scss" scoped>
.footer-container {
  width: 100%;
  // background: #00cc7e;
  padding-top: 46px;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  font-size: 1rem;
}

.footer-container .w {
  position: relative;
  max-width: 1200px;
  margin: auto;
}

.footer-container .w .top {
  font-size: 2.4rem;
  font-weight: bold;
  color: #888;
  margin-bottom: 40px;
}

.footer-container .w .bottom {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.footer-container .w .bottom .left {
  width: 100%;
}
.footer-container .w .bottom .left .box {
  // background: #43d798;
  border-radius: 4px;
  display: flex;
  padding: 22px;
  margin-top: 18px;
  color: #000;
}
.footer-container .left img {
  margin-top: 16px;
  width: 45px;
  height: 45px;
}
.footer-container .left .name {
  width: 220px;
  color: #333;
  font-weight: bold;
  text-align: center;
  font-size: 1rem;
}
.footer-container .left .flex-row {
  display: flex;
  margin: 20px 0;
}
.footer-container .left .list-item p {
  margin: 0 0 8px 0;
}
.footer-container .left .list-top i {
  font-size: 1.8rem;
  padding-right: 4px;
  font-weight: bold;
  padding-left: 10px;
}
.footer-container .left .list-top i:first-child {
  padding-left: 0;
}
.footer-container .left .list-item p:before {
  content: '';
  display: inline-block;
  margin-right: 8px;
  width: 8px;
  height: 8px;
  background: #000;
  transform: rotate(45deg);
}
.footer-container .left .name p:first-child {
  font-size: 2rem;
  margin-bottom: 10px;
}

.footer-container h2 {
  margin-top: 64px;
  width: 156px;
  height: 38px;
  color: #000;
  font-size: 2rem;
  font-weight: 600;
  background-size: cover;
  margin-top: 28px;
}

.footer-container .tel {
  margin-top: 20px;
}

.footer-container .w .bottom .right {
  width: 35%;
  text-align: right;
  padding-top: 40px;
}
.footer-container .w .bottom .right .logo {
  height: 80px;
}
.footer-container .w .bottom .right .code {
  display: flex;
  justify-content: flex-end;
}
.footer-container .w .bottom .right .code .img {
  width: 10rem;
  height: 174px;
  text-align: center;
  color: #eee;
  margin: 60px 0 0 60px;
}

.company {
  padding-top: 20px;
  line-height: 47px;
  // background: #00cc7e;
}
.company .w {
  // border-top: 1px solid #00b541;
  text-align: center;
  color: #888;
  padding: 20px 0;
  max-width: 1200px;
  margin: auto;
}

@media screen and (max-width: 1200px) {
  .footer-container .w .bottom .left {
    width: 100%;
  }
  .company .w{
    width: 100%;
  }
  .footer-container .w{
    width: 100%;
  }
  .footer-container .w .bottom .right{
    width: 70%;
  }
}

@media screen and (max-width: 1200px) {
  .footer-container{
    font-size: 1.3rem !important;
  }
  .company{
    font-size: 1rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/footer.vue